module.exports = __webpack_public_path__ + "assets/img/slogan-1e9d29ca.png";